<template>
    <SimpleWidgetPageWithSwitcher
        v-if="widgetPage"
        :widget-page-id="widgetPageId"
        :widget-type="widgetPage?.type"
        :dependencies="dependencies"
        :switcher="widgetPage?.switcher"
        :placeholder-item-count="5"
        @widget-page-id-change="emit('widgetPageIdChange', $event)"
    >
        <template #placeholder-item>
            <div class="py-4 space-y-2 transition-opacity">
                <UIGhostLoader type="h3" />
                <UIGhostLoader
                    type="h2 mb-2"
                    no-margin
                />
                <UIGhostLoader
                    type="p"
                    no-margin
                />
            </div>
        </template>
        <StudentDueWorkItem
            v-for="(item, index) in displayItems"
            :key="index"
            :item="item"
            :is-last="index === displayItems.length - 1"
        />
    </SimpleWidgetPageWithSwitcher>
</template>

<script setup>
    import { orderBy } from 'lodash'
    import dayjs from '@/dayjs'

    import { useWidgetsStore } from '@/stores/widgets'
    import { useWidgetPagesStore } from '@/stores/widgetPages'
    import StudentDueWorkItem
        from '@/components/next-gen/widgets/student-due-work/StudentDueWorkItem.vue'

    const emit = defineEmits(['widgetPageIdChange'])

    const props = defineProps({
        widgetPageId: String,
    })

    const widgetsStore = useWidgetsStore()
    const widgetPagesStore = useWidgetPagesStore()

    const { widgetPages } = storeToRefs(widgetPagesStore)

    const widgetPageMetadata = computed(() => widgetPages.value?.[props.widgetPageId])
    const widgetPage = computed(() => widgetPageMetadata.value?.data)

    const dependencies = computed(() => {
        return widgetPage.value?.dependencies ?? []
    })

    const itemsByDate = computed(() => {
        return orderBy(
            widgetsStore.items(widgetPage.value?.type, dependencies.value),
            (item) => {
                return dayjs(item.due_date).toDate()
            },
            'asc',
        )
    })

    const displayItems = computed(() => {
        return itemsByDate.value
    })
</script>
